import React from "react";

const Galerie = () => {
  return <div>Galerie</div>;
};

export default Galerie;
